import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';

import { ApiRegisterPickUpInformation } from 'src/app/pick-up/models/pick-up.model';

import { Environment } from 'src/environments/environment';

import {
  GrainRegistration,
  Cultivation,
  GrainCertificate,
  CustomerGrowerReference,
  RegistrationDefaultValues,
} from '../models/grain-registration.model';

@Injectable({
  providedIn: 'root',
})
export class GrainRegistrationService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private readonly arableServiceUrl = `${this.env.APIM_BASE_URL}/arable-service`;

  saveRegistration(grainRegistration: GrainRegistration) {
    return this.http.post<GrainRegistration>(
      `${this.arableServiceUrl}/grainregistration/registration`,
      grainRegistration,
      {},
    );
  }

  getCultivations() {
    return this.http.get<Array<Cultivation>>(
      `${this.arableServiceUrl}/grainregistration/cultivation`,
      {},
    );
  }

  getGrainCertificates() {
    return this.http.get<Array<GrainCertificate>>(
      `${this.arableServiceUrl}/grainregistration/certificate`,
      {},
    );
  }

  getCustomerGrower() {
    return this.http.get<CustomerGrowerReference>(
      `${this.arableServiceUrl}/grainregistration/customer`,
      {},
    );
  }

  getRegistrationDefaultValues(cultivationId: string) {
    return this.http.get<RegistrationDefaultValues>(
      `${this.arableServiceUrl}/grainregistration/registration/defaultvalues/${cultivationId}`,
      {},
    );
  }

  savePickUpRequest(year: number, pickUpInformation: ApiRegisterPickUpInformation) {
    return this.http.post(
      `${this.arableServiceUrl}/grainregistration/grainpickuprequest/register/${year}`,
      pickUpInformation,
    );
  }
}
